<template>
  <div class="navHeader" :class="locale === 'en'?'navHeader-en':''">
    <div class="nav-logo">
      <a style="cursor: pointer;" @click="tofind()" class="navbar-brand">
            <img width="25" height="25" src="@/assets/image/svg/logo.svg" alt="">
        <span>{{ $t("header.logo") }}</span>
      </a>
    </div>

    <div class="header_main">
      <nav data-bs-theme="dark" class="navbar bg-dark navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
            aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            <!-- <span class="bi bi-menu"></span> -->
          </button>
          <div class="collapse navbar-collapse" id="navbarText">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li style="cursor: pointer;" v-for="item in navList" :key="item.text"
                class="nav-item newnav_item">
                <div style="font-weight: 700;" class="nav-link newnavlink parent-nav" aria-current="page">
                  <div :class="['parent-nav-text', item.isactive ? 'newactive' : '']" @click="handleNavClick(item)">{{ item.text }}</div>
                  <!-- <div v-if="item.children && item.children.length > 0" class="sub-nav-wrap">
                    <div
                      v-for="(subnav, index2) in item.children" :id="index2" :key="index2"
                      :class="['children-nav', subnav.isactive ? 'newactive' : '']"
                      @click="handleNavClick(subnav)"
                      >
                      {{ subnav.text }}
                    </div>
                  </div> -->
                </div>
              </li>
              <!-- TODO -->
              <li v-if="!islogin" class="nav-item mb_login ">
                <a @click="toRegister" :class='["nav-link", "newnavlink"]' aria-current="page">注册认证</a>
              </li>
              <li v-if="!islogin" class="nav-item mb_register ">
                <a @click="toLogin" :class='["nav-link", "newnavlink"]' aria-current="page">账号登录</a>
              </li>
              <li v-if="islogin" class="nav-item mb_login ">
                <a :class='["nav-link", "newnavlink"]' aria-current="page">欢迎您 {{ mobile }}</a>
              </li>
              <li v-if="islogin" class="nav-item mb_login ">
                <a @click="toControlHome" :class='["nav-link", "newnavlink"]' aria-current="page">【控制台】</a>
              </li>
              <li v-if="islogin" class="nav-item mb_register ">
                <a @click="tologout" :class='["nav-link", "newnavlink"]' aria-current="page">退出</a>
              </li>
            </ul>

            <!-- <div v-if="islogin">
              <span class="navbar-text nav_login sign mob">
                欢迎您 {{ mobile }}
              </span>
              <span @click="toControlHome" class="navbar-text nav_login sign">
                【控制台】
              </span>
              <span @click="tologout" class="navbar-text nav_login sign">
                退出
              </span>
            </div> -->

          </div>
        </div>
      </nav>
    </div>

    <div v-if="!islogin" class="nav-control">
        <!-- <span @click="toRegister" class="navbar-text nav_login sign">
          注册认证
        </span> -->
        <span @click="toLogin" class="navbar-text nav_register sign">
          {{ $t("header.userEntrance") }}
        </span>
      </div>


    <div  v-if="islogin" class="nav-control">
      <div class="loginInfo">
        <span @click="router.push({ path: '/home/controlinformation', query: { type: 'third' } })"
                  class="navbar-text nav_login sign mess " style="font-weight: bold;">
                    {{ $t("header.messages") }}
                    <span v-if="store.state.user.unReadnum" class="brage"></span>
                  <!-- <span v-if="store.state.user.unReadnum" class="brage">{{ store.state.user.unReadnum }}</span> -->
        </span>
        <span class="navbar-text nav_login sign" >
          <li class="nav-item dropdown">
            <!-- <img style="transform: translateY(-2px);margin-right: 5px;" src="@/assets/image/userimg.png" alt=""> -->
            <a class="nav-link drop_nav" role="button">
              <span class="des_one_row font_bold" >{{ hidePhone(mobile) }}</span>
              <!-- <img style="transform: translateY(-2px);margin-left: 5px;font-weight: bold;" src="@/assets/image/select.svg" alt=""> -->

              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M9.24268 4.75781L5.00004 0.515172L0.757395 4.75781" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <ul>
                <li @click="router.push({ path: '/home/controlsyshome', query: { type: 'first' } })">{{ $t("header.console") }}</li>
                  <li @click="router.push({ path: '/home/controlinformation', query: { type: 'first' } })">{{ $t("header.personalCenter") }}</li>
                  <!-- // TODO 1.2内容 暂时隐藏订单中心 -->
                  <!-- <li @click="router.push({ path: '/home/controlinformation', query: { type: 'fourth' } })">订单中心</li> -->

                <li @click="tologout">{{ $t("header.logout") }}</li>
              </ul>
            </a>
          </li>
        </span>
      </div>
    </div>

  </div>
</template>
<script setup>
import { reactive, onMounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { userLogout } from '@/api/common'
import { ElMessageBox } from 'element-plus'
import { getToken } from "@/utils/cookies"
import { downloadFile } from "@/utils/downloadFile";
import { jen_configUrl, Simulator_Download_Url } from '@/config/index.js'
import { hidePhone } from '@/utils/common.js'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const islogin = ref(false)
const router = useRouter()
const route = useRoute();
const store = useStore()
const mobile = ref('')

//导航数据列表
let navList = reactive([
  {
    text: t("header.discover"),  // '发现',
    path: '/home/find',
    isactive: true
  },
  // {
  //   text: '产品',
  //   path: '/home/product',
  //   isactive: false
  // },
  // {
  //   text: '解决方案',
  //   path: '/home/Solution',
  //   isactive: false
  // },
  {
    text: t("header.documents"),
    path: '/home/resourceCenter',
    isactive: false
  },
  {
    text: t("header.downloads"),
    path: '/newDownload', // 新下载页
    isactive: false,
    children: [
      {
        text: t("header.resourceDownloads"),
        path: '/downloads',
        isactive: false,
      },
      {
        text: t("header.appDownload"),
        path: '/downloadApp',
        isactive: false,
      },
      {
        text: t("header.simulationDownloads"),
        path: Simulator_Download_Url,
        isactive: false,
      },
    ]
  },
  {
    text: t("header.about"),
    path: '/home/about',
    isactive: false
  },
])

onMounted(() => {
  console.log(store.state.user.islogin,'我登录了吗---');
  if (store.state.user.islogin) {
    islogin.value = true
    mobile.value = store.state.user.mobile()
    // console.log(mobile.value);

    store.dispatch('getUserUnReadNum')

  }
  // tofind()



})
//跳转登录页
const toLogin = () => {
  router.push('/login')
}
//跳转控制台
const toControlHome = () => {
  // window.open(`${location.origin}${jen_configUrl}controlhome`, '_blank')
  // console.log(location);
  router.push('/home/controlsyshome')
}
//退出登录
const tologout = () => {
  // console.log('store.state.user.islogin',store.state.user.islogin,getToken());
  if(!getToken()){
    islogin.value = false
    return
  }
  ElMessageBox.confirm(t("login.confirmLogout"), "", {
    confirmButtonText: t("login.confirm"),
    cancelButtonText: t("login.cancel"),
    showClose:false,
    center:true,
    autofocus:false,
    // type: "warning",
    customClass: 'my-logout-class'
  }).then(() => {
    userLogout().then(res => {
      if (res.code == 200) {
        store.dispatch('logOut')
        if (!store.state.user.islogin) {
          tofind()
          islogin.value = false
        }
      }
      // console.log(res);
    }).catch(err => { console.log(err); })
  })
}
//跳转注册页
const toRegister = () => {
  router.push('/register')
}
//跳转发现页
const tofind = () => {
  handleNavClick({
    text: t("header.discover"),
    // path:'/home/newsdetail',
    path: '/home/find',
    isactive: true
  })
}
//点击导航栏
const handleNavClick = (item) => {
  handlenavState()

  //说明在下载页，且点击的还是下载页，做特殊处理
  if(item.path.includes('https://')){
    // window.open(item.path, '_blank')
    downloadFile(item.path);
    return
  }
  router.push(item.path)

  // router.push(item.path).then(() => {
  //   handlenavState()
  // }).catch(() => {
  //   // ignore
  // })
}

//修改导航栏状态
const handlenavState = () => {
  setActive(navList, {})
}

const setActive = (arr, parentItem, path) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].path === route.path ) {
      // console.log('setActive--true--: ',arr[i],arr[i].path, route.path);
      arr[i].isactive = true;
      if(parentItem.text !== '') {
        parentItem.isactive = true
      }
    } else {
      // console.log('setActive--false--: ',arr[i]);
      arr[i].isactive = false;
    }
    if(arr[i].children && arr[i].children.length) {
      setActive(arr[i].children, arr[i])
    }
  }

}
watch(
  () => route.path,
  (val) => {
    handlenavState()
  },
  { immediate: true }
)
</script>
<style lang="scss" scoped>
$main-color:#386AEA!important;

.navbar-brand {
  margin-left: 48px;
  transform: translateY(-1px);

  span{
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    margin-left: 12px;
  }
}

.loginInfo{
  margin-right: 48px;

  .brage{
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #E70A27;
    border-radius: 50%;
    margin-left: 1px;
    transform: translateY(-7px);
  }
  .dropdown:hover{
    svg {
        transform: rotate(0);
      }
  }
  .nav-link.drop_nav {
    position: relative;
    margin-left: 58px;
    // width: 134px;
    max-width: 241px;
    min-width: 134px;
    padding-left: 24px!important;
    padding-right: 24px!important;
    display: flex;
    align-items: center;
    justify-content: center;

    .des_one_row{
      margin-right: 4px;
    }

    svg {
        transform: rotate(180deg);
        margin-left: 2px;
      }

    ul {
      display: none;
      padding: 0;
      margin: 0;
      position: absolute;
      z-index: 99;
      top: 56px;
      height: 168px;
      // width: 134px;
      width: 100%;
      left: 0px;
      background-color: #272727;
      border-radius: 0px 0px 4px 4px;

      li{
        width: 100%;
        text-align: center;
      }
    }
  }

  .drop_nav:hover {
    // background-color: #272727;
    background-color:rgba(56, 106, 234, 0.1);
    color: #fff;

    ul {
      display: block;
    }
  }

  .drop_nav {
    li:hover {
      color: #386AEA;
      background-color: rgba(56, 106, 234, 0.1);
    }
  }

  .mess:hover{
    color: #386AEA;
  }

}

.sign:not(.mob) {
  height: 56px !important;
  line-height: 56px;
  display: inline-block;
  height: 100%;
  cursor: pointer;
}

.navHeader {
  background-color: #111;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .nav-logo {
    width: 408px;
  }
  .nav-control {
    width: 488px;
    display: flex;
    justify-content: flex-end;
  }

  .bg-body-tertiary {
    background-color: #111 !important;
  }

  .newactive {
    color: $main-color;
  }

  .newnav_item {
    // width: 128px;
    text-align: center;
    .nav-link {
      padding: 0;
    }
  }
  .newnav_item:nth-last-of-type(){
    margin-right: 0!important;
  }

  .newnavlink {
    color: #fff;
  }
  .parent-nav {
    position: relative;
    &:hover {
      .sub-nav-wrap {
        display: block;
      }
    }
    .parent-nav-text {
      padding: 0 48px;
      width: 100%;
      height: 100%;
      &:hover {
        background-color: rgba(56, 106, 234, 0.1);
      }
    }
    .sub-nav-wrap {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 100;
      width: 100%;
      top: 56px;
      border-radius: 0px 0px 4px 4px;
      background: #272727;
      .children-nav {
        &:hover {
          color: rgba(56, 106, 234, 1);
          background-color: rgba(56, 106, 234, 0.1);
        }
      }
    }
  }
}

.nav-item .nav-link {
  padding: 0px 32px;
  height: 56px;
  line-height: 56px;
}

.header_main {
  background-color: #111;
  margin: 0 auto;
  flex: 1;
  display: flex;
  justify-content: center;
}


li{
  list-style: none;
}



// 英文版样式
.navHeader-en{
  .sub-nav-wrap{
    width: 226px!important;
    // padding: 0 24px;
  }
}

@media (max-width: 1645px) and (min-width: 1410px){
  .navHeader{
    .nav-logo{
      width: 27%!important;
    }
    .nav-control{
      width: 29%!important;
    }
  }

  .navHeader-en{
    .newnav_item{
      .parent-nav-text{
        padding: 0 31px!important;
      }
    }
  }

}

@media (max-width: 1410px) and (min-width: 992px){
  .navHeader{
    .nav-logo{
      width: 26%!important;
    }
    .nav-control{
      max-width: 30%!important;
    }
    .newnav_item{
      .parent-nav-text{
        padding: 0 39px!important;
      }
    }
  }


  .navHeader-en{
    .newnav_item{
      .parent-nav-text{
        padding: 0 12px!important;
      }
    }
  }
}


@media (max-width: 992px) {

  .nav_login,
  .nav_register {
    display: none;
  }
}

@media (min-width: 992px) {

  .mb_login,
  .mb_register {
    display: none;
  }

  .nav_login {
    color: #fff;
    padding: 0px;
    font-weight: 500;
  }


  .nav_register {
    // background-color: #0041BF;
    padding: 0px 48px;
    color: #fff;
    font-weight: 500;
  }

  .nav_register:hover {
    // background: #27FF97;
    color: #386AEA;
  }

  nav.navbar.bg-dark.navbar-expand-lg.bg-body-tertiary {
    padding: 0px;
  }

  .header_main {
    max-width: 1128px;
  }
}

</style>